import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { loadPlatformWebConfig } from "./config";
import { CasaNativaPublic } from "./demos/gastronomy/reference-restaurant/CasaNativaPublic";
import { RestaurantCommercialDemo, RESTAURANT_COMMERCIAL_DEMO_PUBLIC_PATH } from "./demos/restaurant-commercial/RestaurantCommercialDemo";
import { SalesPlayground, SALES_PLAYGROUND_PUBLIC_PATH } from "./demos/sales-playground/SalesPlayground";
import { CASA_NATIVA_PUBLIC_PATH } from "./routes";
import { SalonsPublicBooking } from "./salons/SalonsPublicBooking";
import "@clickdialog/ui/tokens.css";
import "./styles.css";
import "./platform-theme.css";
import "./reputation-theme.css";
import "./menu-theme.css";
import "./custom-theme.css";
import "./mesa28-v2-admin.css";
import "./custom-analytics-theme.css";
import "./meta-whatsapp-review-theme.css";
import "./mobile-theme.css";
import "./platform-brand-v1.css";
import "./platform-brand-v1-states.css";
import "./adaptive-ui-v1.css";
import "./adaptive-ui-v1-navigation.css";
import "./adaptive-ui-v1-primitives.css";
import "./adaptive-ui-v2-primitives.css";
import "./adaptive-ui-v2-operational.css";
import "./adaptive-ui-v3-actions.css";
import "./crm.css";
import "./crm-insights.css";
import "./support-access.css";
import "./demos/demos.css";
import "./gastro-sales-demo/gastro-sales-demo.css";
import "./demos/gastronomy/reference-restaurant/casa-nativa.css";
import "./demos/gastronomy/reference-restaurant/casa-nativa-admin-shell.css";
import "./demos/gastronomy/reference-restaurant/casa-nativa-v2.css";
import "./demos/sales-playground/sales-playground.css";
import "./demos/sales-playground/restaurant-demo-workspace.css";
import "./demos/sales-playground/restaurant-demo-v4.css";
import "./demos/sales-playground/restaurant-demo-v5.css";
import "./demos/sales-playground/restaurant-agent-v7.css";
import "./demos/sales-playground/restaurant-customer-experience.css";
import "./demos/sales-playground/restaurant-customer-webchat.css";
import "./demos/sales-playground/restaurant-customer-handoff-tray.css";
import "./demos/sales-playground/restaurant-customer-experience-cx6.css";
import "./demos/restaurant-commercial/restaurant-commercial-demo.css";
import "./demos/restaurant-commercial/restaurant-commercial-admin-depth.css";
import "./demos/restaurant-commercial/restaurant-commercial-editor-polish.css";
import "./demos/restaurant-commercial/restaurant-commercial-public-landing.css";

import "./experience.css";
import "./salons/clickdialog-main.css";
import "./salons/services-ux-v1.css";
import "./salons/salons-ux-v1.css";
import "./salons/public-booking.css";
import "./reputation-layout-v3.css";

const root = document.getElementById("root");
if (!root) throw new Error("platform_web_root_missing");

const pathname = window.location.pathname;
const salonPublicBookingMatch = pathname.match(
  /^\/salons\/([a-z0-9](?:[a-z0-9-]{0,62}))\/book\/?$/,
);
const casaNativaRequested = window.location.pathname === CASA_NATIVA_PUBLIC_PATH;
const salesPlaygroundRequested = pathname === SALES_PLAYGROUND_PUBLIC_PATH || pathname.startsWith(`${SALES_PLAYGROUND_PUBLIC_PATH}/`);
const restaurantCommercialRequested = pathname === RESTAURANT_COMMERCIAL_DEMO_PUBLIC_PATH || pathname.startsWith(`${RESTAURANT_COMMERCIAL_DEMO_PUBLIC_PATH}/`);
const environment = loadPlatformWebConfig().environment;
const notFound = <main className="status-page" id="main-content"><section className="status-card"><p className="eyebrow">404</p><h1>Page not found</h1><p>This route is not available.</p></section></main>;

const surface = salonPublicBookingMatch
  ? <SalonsPublicBooking slug={salonPublicBookingMatch[1]!} />
  : restaurantCommercialRequested
  ? environment === "production"
    ? notFound
    : <RestaurantCommercialDemo navigate={(path) => window.location.assign(path)} />
  : salesPlaygroundRequested
    ? environment === "production"
      ? notFound
      : <SalesPlayground navigate={(path) => window.location.assign(path)} />
    : casaNativaRequested
      ? environment === "production"
        ? notFound
        : <CasaNativaPublic />
      : <App />;

createRoot(root).render(<StrictMode>{surface}</StrictMode>);